import Main from './common/main';

const main = new Main();